import type {
  CalculationMode,
  FormulaBreakdown,
} from '@bioavail/shared-types';
import { buildFormula } from '../bioavailability/absoluteF';

/**
 * Build the substituted formula breakdown (F-035).
 * Delegates to buildFormula; kept as a separate module per the deliverables.
 */
export function buildFormulaBreakdown(
  mode: CalculationMode,
  selectedAucTest: number,
  selectedAucReference: number,
  doseTest: number,
  doseReference: number,
  fResult: {
    fRaw: number;
    fDoseCorrected: number;
    fPercent: number;
    doseNormalized: boolean;
  },
): FormulaBreakdown {
  return buildFormula(
    mode,
    selectedAucTest,
    selectedAucReference,
    doseTest,
    doseReference,
    fResult,
  );
}

/**
 * Interpretation band text (F-036).
 * < 20% "Low", 20–50% "Moderate", 50–80% "Good", > 80% "High".
 * Relative mode uses "relative" wording, not bounded by 100%.
 */
export function interpretationBand(fPercent: number, mode: CalculationMode): string {
  const kind = mode === 'absolute' ? 'bioavailability' : 'relative bioavailability';
  if (fPercent < 20) return `Low ${kind} (< 20%)`;
  if (fPercent < 50) return `Moderate ${kind} (20–50%)`;
  if (fPercent < 80) return `Good ${kind} (50–80%)`;
  return `High ${kind} (> 80%)`;
}
